import React, { useEffect, useState } from 'react';

interface LazyAgentInputProps {
  id: string;
}

/**
 * Essio 页面检测到 AgentInput 容器 id 后再异步加载，避免 PSEO 页默认可编译首页输入框依赖树。
 */
function LazyAgentInput({ id }: LazyAgentInputProps) {
  const [Comp, setComp] = useState<React.ComponentType<LazyAgentInputProps> | null>(null);

  useEffect(() => {
    let cancelled = false;
    import('@/pages/--roboneo/landing_page/components/AgentInput').then((mod) => {
      if (!cancelled) {
        setComp(() => mod.default);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!Comp) {
    return null;
  }

  return <Comp id={id} />;
}

export default LazyAgentInput;
